import _ from 'lodash';

export interface Action<Type = string> {
  type: Type;
}

export type Reducer<A, S> = (action: A, state: S) => S;

export const createGenericReducer = <S, ActionsMap>(initialState: S, actionMap: Partial<ActionsMap> = {}) => (
  prevState: S = initialState,
  action: Action,
): S => {
  // Ignoring to bypass some Typescript checks which do not help here.
  // @ts-expect-error
  const actionReducer = actionMap[action.type];

  if (!actionReducer) {
    return prevState;
  }

  const newState = actionReducer(action, prevState);

  if (_.isPlainObject(newState) && _.isPlainObject(prevState)) {
    // TODO: check how to type
    return { ...prevState, ...newState };
  }

  return newState;
};

export default createGenericReducer;
